import { Field, ObjectType } from '@nestjs/graphql'

/**
 * What an author told us in the checkout's Business Info step, handed back to pre-fill it [sc-29190]. Only
 * their own answers: staff's review and notes are on AdminPublisherApplicationDto, which authors never get.
 */
@ObjectType()
export class PublisherApplicationDto {
  @Field({ nullable: true })
  website?: string

  @Field({ nullable: true })
  information?: string

  @Field(t => Date, { nullable: true })
  submittedDate?: Date
}
